import { colors } from 'ui/theme';
import { getColor } from 'ui/icons/utils';
import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';

export const QualityRatingLow = ({
  height = 16,
  width = 16,
  color = colors.warning100,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      className="useInlineFill"
      d="M13.5 1C12.6716 1 12 1.67157 12 2.5V13.5C12 14.3284 12.6716 15 13.5 15C14.3284 15 15 14.3284 15 13.5V2.5C15 1.67157 14.3284 1 13.5 1Z"
      fill={getColor(color, isColorInherited)}
      opacity={0.2}
    />
    <path
      className="useInlineFill"
      d="M8 5C7.17157 5 6.5 5.67157 6.5 6.5V13.5C6.5 14.3284 7.17157 15 8 15C8.82843 15 9.5 14.3284 9.5 13.5V6.5C9.5 5.67157 8.82843 5 8 5Z"
      fill={getColor(color, isColorInherited)}
      opacity={0.2}
    />
    <path
      className="useInlineFill"
      d="M2.5 9C1.67157 9 1 9.67157 1 10.5V13.5C1 14.3284 1.67157 15 2.5 15C3.32843 15 4 14.3284 4 13.5V10.5C4 9.67157 3.32843 9 2.5 9Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
